module.exports = __webpack_public_path__ + "img/img-7.b109cb08.webp";